import React from 'react'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import styled from 'styled-components'
import Icons from '../../Icons'
import {
  StyledContainer,
  StyledItem,
  StyledIcon,
  StyledImage
} from './StyledSearchResult'
import Avatar from '../../Avatar/Avatar'

const ResultContainer = styled.div`
  height: calc(100% - 10px);
  margin-top: 10px;
`

const generateDepartmentKey = (department, idx) => {
  let rm_id = department['rm.rm_id'] ? department['rm.rm_id'] : idx
  return (
    department['rm.dv_id'] +
    department['rm.dp_id'] +
    department['rm.fl_id'] +
    rm_id
  )
}

const DepartmentResult = ({departments, documents, onItemClick, isSmall}) => {
  const localeState = useLocaleState()
  return (
    <ResultContainer>
      {departments.map((dp, idx) => {
        let isActiveFloor = dp['rm.is_active_self_svc'] === 1

        let building = isActiveFloor ? dp['bl.bl_name'] : ''
        let floor = isActiveFloor
          ? `${_L({key: 'Floor', localeState})} ${dp['rm.fl_id']}`
          : ''

        const {image_url} = documents[`bl-${dp['rm.bl_id']}`] || {}

        let item = {
          blId: dp['rm.bl_id'],
          flId: dp['rm.fl_id'],
          deptKey: {dvId: dp['rm.dv_id'], dpId: dp['rm.dp_id']}
        }

        return (
          <StyledContainer
            key={generateDepartmentKey(dp, idx)}
            onClick={evt => onItemClick({type: 'dp', item, evt})}
          >
            <StyledImage isSmall={isSmall}>
              <Avatar url={image_url} large type="building" />
            </StyledImage>
            <StyledItem isBold gridRow="1" gridColumn="2 / span 2">
              <span>{dp['dp.name']} </span>
            </StyledItem>
            <StyledItem gridRow="2" gridColumn="2 / span 2">
              {dp['dv.dv_name']}
            </StyledItem>
            <StyledItem
                gridRow={isSmall ? '3' : '1'}
                gridColumn={isSmall ? '2' : '4'}
                color="#52555B"
            >
              {floor}
            </StyledItem>
            <StyledItem
                gridRow={isSmall ? '4' : '2'}
                gridColumn={isSmall ? '2' : '4'}
                color="#52555B"
            >
              {building}
            </StyledItem>
          </StyledContainer>
        )
      })}
    </ResultContainer>
  )
}

export default DepartmentResult
